import { initConsoleIntegration } from './integrations/console.node'
import { initOpenTelemetryIntegration } from './integrations/otel.node'
import { getConfig } from '@/tools/config'

export const initCustomMetrics = () => {
  const { env } = getConfig()
  if (env === 'prod' || env === 'stage') {
    initOpenTelemetryIntegration()
  } else {
    initConsoleIntegration()
  }
}
